import { DateTime } from "luxon";
import { ReactElement } from "react";
import { FormattedDate, FormattedMessage, FormattedTime } from "react-intl";

export default function FormattedDateTime({
  value,
}: {
  value: number;
}): ReactElement {
  return (
    <FormattedMessage
      defaultMessage="{date} at {time} {timezone}"
      description="Date and time"
      values={{
        date: (
          <FormattedDate
            value={value}
            year="numeric"
            month="long"
            day="numeric"
          />
        ),
        time: <FormattedTime value={value} />,
        timezone: DateTime.fromMillis(value).toFormat("ZZZZ"),
      }}
    />
  );
}
